/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Toast_CreatedInputs */

const he_notifications_toast_created = /** @type {(inputs: Notifications_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתראה נוספה בהצלחה`)
};

const en_notifications_toast_created = /** @type {(inputs: Notifications_Toast_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notification enabled`)
};

/**
* | output |
* | --- |
* | "Notification enabled" |
*
* @param {Notifications_Toast_CreatedInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_toast_created = /** @type {((inputs?: Notifications_Toast_CreatedInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Toast_CreatedInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_toast_created(inputs)
	return en_notifications_toast_created(inputs)
});